<template>
   <el-tabs type="border-card">
    <el-tab-pane label="供应商管理 > 供应商列表">
      <div style="margin-top:16px;">
        <el-table
          :data="data"
          size = "small"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="companyName"
            show-overflow-tooltip
            label="供应商名称">
          </el-table-column>
          <el-table-column
            prop="brandName"
            show-overflow-tooltip
            label="品牌">
          </el-table-column>
          <el-table-column
            :formatter="formatType"
            prop="type"
            show-overflow-tooltip
            label="类别">
          </el-table-column>
          <el-table-column
            prop="userName"
            show-overflow-tooltip
            label="联系人">
          </el-table-column>
          <el-table-column
            prop="mobile"
            show-overflow-tooltip
            label="联系电话">
          </el-table-column>
          <el-table-column
            prop="emailAddress"
            show-overflow-tooltip
            label="邮箱地址">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      supplierSettleForm: {
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getAritcleList()
  },
  methods: {
    getAritcleList: function() {
      this.optionItem = this.common.extend(this.supplierSettleForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/supplier/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    formatType: function(row, column, cellValue) {
      if (cellValue === 0) {
        return "原厂";
      } else if (cellValue === 1) {
        return "代理商";
      }
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getAritcleList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getAritcleList()
    }
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/supplier/supplierList.vue